import React, { useState, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import pfp from "@/assets/img/dairectLogo.png";
import { useTranslation } from "react-i18next";

const AccountManagerCard = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [footerHeight, setFooterHeight] = useState<number>(0);
  const [isFooterVisible, setIsFooterVisible] = useState<boolean>(false);

  useEffect(() => {
    const updateHeight = () => {
      const footerEl = document.getElementById("footer");
      if (footerEl) {
        setFooterHeight(footerEl.offsetHeight);
      }
    };

    // Initial height
    updateHeight();

    // Recalculate on window resize
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  useEffect(() => {
    const footer = document.getElementById("footer");

    if (!footer) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsFooterVisible(entry.isIntersecting);
      },
      {
        threshold: 0.1, // Adjust based on how much of footer should be visible
      }
    );

    observer.observe(footer);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <div
        className={`flex flex-col w-full justify-between border rounded-xl p-3 shadow-md bg-white mt-2 md:m-0`}
      >
        <div className="mb-5">
          <p className="text-sm">{t("support.need_help")}</p>
          <p className="text-xs text-gray-400">
            {t("support.contact_operator")}
          </p>
        </div>
        <div
          className="flex w-full items-center justify-between cursor-pointer"
          onClick={() => setOpen((p) => !p)}
        >
          <div className="flex gap-2 items-center h-full w-full">
            <div
              className="aspect-square h-full rounded-full"
              style={{
                backgroundImage: `url(${pfp})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            />
            <div>
              <p className="text-sm">Account manager</p>
            </div>
          </div>
          <ChevronDown
            className={`h-6 w-6 duration-300 ease-in-out ${
              open ? "rotate-180" : ""
            }`}
            color="black"
          />
        </div>
        <div className={`expander ${open ? "expanded" : ""}`}>
          <div className={`expander-content ${open ? "expanded" : ""}`}>
            <div className="pt-5 pb-0 text-sm">
              <a href="mailto:partner.support@dairect.io">
                partner.support@dairect.io
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="hidden md:block">
        <div
          className={`duration-150 ease-out`}
          style={{
            marginBottom: isFooterVisible ? footerHeight : 0,
          }}
        />
      </div>
    </>
  );
};

export default AccountManagerCard;
